import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import { appLocales, Locales } from "@/lib/i18n";
import { PrismicNextLink } from "@prismicio/next";

/**
 * Props for `SectionLinks`.
 */
export type SectionLinksProps = SliceComponentProps<Content.SectionLinksSlice> & {
  context?: { locale?: Locales };
};

/**
 * Component for "SectionLinks" Slices.
 */
const SectionLinks: FC<SectionLinksProps> = ({ slice, context }) => {
  const locale = context?.locale || appLocales.defaultLocale;
  const { title, link, link_label, links } = slice.primary;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-pink-primary flex w-full flex-col gap-7 px-6 py-10 md:px-12"
    >
      <header className="container flex flex-col items-center gap-3 md:flex-row md:justify-between xl:px-7.5">
        <h2 className="font-cabinet-grotesk text-center text-3xl font-medium text-white md:text-left">{title}</h2>
        <PrismicNextLink
          className="focus-visible:ring-dark-primary/70 rounded-sm text-base font-medium text-white underline focus-visible:ring-[3px] focus-visible:ring-offset-3 focus-visible:outline-none md:uppercase"
          locale={locale}
          field={link}
        >
          {link_label}
        </PrismicNextLink>
      </header>

      <div className="container flex flex-wrap items-center gap-2 xl:px-7.5">
        {links.map((cta, idx) => (
          <PrismicNextLink
            locale={locale}
            key={idx}
            field={cta.link}
            className="text-pink-primary bg-white p-5 text-lg"
          >
            {cta.link_label}
          </PrismicNextLink>
        ))}
      </div>
    </section>
  );
};

export default SectionLinks;
